// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"BusinessInfo_infoContainer__1fZsG","questionMark":"BusinessInfo_questionMark__6w2GU","infoText":"BusinessInfo_infoText__tjQP-"};